/*
 * <hero-carousel> custom element.
 * One slide visible at a time; supports optional arrows, progress bars, autoplay
 * (pauses on hover / focus / hidden tab), touch swipe and keyboard arrows.
 * The progress-bar fill is a CSS animation — JS only toggles a class and forces a
 * reflow so it restarts cleanly. No dependencies.
 */
if (!customElements.get('hero-carousel')) {
  customElements.define(
    'hero-carousel',
    class HeroCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.hc__track');
        this.bars = Array.from(this.querySelectorAll('.hc__bar'));
        this.index = 0;
        this.count = this.querySelectorAll('.hc__slide').length;
        if (this.count <= 1) return;

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.interval = (parseFloat(this.dataset.interval) || 5) * 1000;
        this.autoplay = this.dataset.autoplay === 'true' && !reduceMotion;

        this.querySelector('.hc__arrow--prev')?.addEventListener('click', () => this.go(this.index - 1));
        this.querySelector('.hc__arrow--next')?.addEventListener('click', () => this.go(this.index + 1));
        this.bars.forEach((bar, i) => bar.addEventListener('click', () => this.go(i)));

        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') this.go(this.index - 1);
          if (e.key === 'ArrowRight') this.go(this.index + 1);
        });

        this.addTouch();

        if (this.autoplay) {
          this.start();
          this.addEventListener('mouseenter', () => this.stop());
          this.addEventListener('mouseleave', () => this.start());
          this.addEventListener('focusin', () => this.stop());
          this.addEventListener('focusout', () => this.start());
          document.addEventListener('visibilitychange', () =>
            document.hidden ? this.stop() : this.start()
          );
        }
      }

      go(i) {
        this.index = (i + this.count) % this.count;
        this.track.style.transform = 'translateX(' + -this.index * 100 + '%)';

        this.bars.forEach((bar, n) => {
          const active = n === this.index;
          bar.classList.remove('is-active');
          if (active) {
            void bar.offsetWidth; // reflow so the fill animation restarts from 0
            bar.classList.add('is-active');
          }
        });

        if (this.autoplay) this.start();
      }

      start() {
        if (!this.autoplay) return;
        this.stop();
        this.timer = setInterval(() => this.go(this.index + 1), this.interval);
      }

      stop() {
        clearInterval(this.timer);
      }

      addTouch() {
        let x0 = null;
        this.track.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
        this.track.addEventListener('touchend', (e) => {
          if (x0 === null) return;
          const dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 40) this.go(this.index + (dx < 0 ? 1 : -1));
          x0 = null;
        }, { passive: true });
      }
    }
  );
}
